module.exports = __webpack_public_path__ + "static/media/GillSans-Light-08.2f159509.svg";